<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Topics
                </h2>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div
                                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                            >
                                <div
                                    class="
                                        py-2
                                        align-middle
                                        inline-block
                                        min-w-full
                                        sm:px-6
                                        lg:px-8
                                    "
                                >
                                    <div
                                        class="
                                            shadow
                                            overflow-hidden
                                            border-b border-gray-200
                                            sm:rounded-lg
                                        "
                                    >
                                        <table
                                            class="
                                                min-w-full
                                                divide-y divide-gray-200
                                            "
                                        >
                                            <thead class="bg-gray-50">
                                            <tr>
                                                <th
                                                    scope="col"
                                                    class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                >
                                                    #
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="py-3 text-left"
                                                >
                                                        <span class="sr-only"
                                                        >Edit</span
                                                        >
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                >
                                                    Title
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                >
                                                    Section
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                >
                                                    Order Number
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                >
                                                    Live
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody
                                                class="
                                                    bg-white
                                                    divide-y divide-gray-200
                                                "
                                            >
                                            <tr
                                                v-for="(
                                                        topic, index
                                                    ) in topics"
                                                :key="topic.id"
                                            >
                                                <td
                                                    class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                >
                                                    {{ index + 1 }}
                                                </td>
                                                <td
                                                    class="
                                                            py-4
                                                            text-left text-sm
                                                            font-medium
                                                        "
                                                >
                                                    <button
                                                        type="button"
                                                        @click="edit(topic)"
                                                        class="
                                                                text-green-600
                                                                hover:text-green-900
                                                                focus:outline-none
                                                            "
                                                    >
                                                        Edit
                                                    </button>
                                                </td>
                                                <td
                                                    class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                >
                                                    {{ topic.title }}
                                                </td>
                                                <td
                                                    class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                >
                                                    {{ topic.section }}
                                                </td>
                                                <td
                                                    class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                >
                                                    {{ topic.topicOrder }}
                                                </td>
                                                <td
                                                    class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-sm
                                                            text-gray-500
                                                        "
                                                >
                                                        <span
                                                            :class="{
                                                                'bg-green-100 text-green-800':
                                                                    topic.live === 'Yes',
                                                                'bg-red-100 text-red-800':
                                                                    topic.live === 'No',
                                                            }"
                                                            class="
                                                                px-2
                                                                inline-flex
                                                                text-xs
                                                                leading-5
                                                                font-semibold
                                                                rounded-full
                                                            "
                                                        >
                                                            {{
                                                                topic.live
                                                            }}
                                                        </span>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
    <dialog-model :show="open" @close="close">
        <template v-slot:title> Edit the Topic. </template>
        <template v-slot:content>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div class="block w-full">
                    <label
                        for="title"
                        class="block text-sm font-medium text-gray-700"
                    >Title</label
                    >
                    <input
                        v-model="form.title"
                        type="text"
                        name="title"
                        id="title"
                        autocomplete="organization-title"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.title"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="topicOrder"
                        class="block text-sm font-medium text-gray-700"
                    >Topic Order</label
                    >
                    <input
                        v-model="form.topicOrder"
                        type="number"
                        name="topicOrder"
                        id="topicOrder"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.topicOrder"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="live"
                        class="block text-sm font-medium text-gray-700"
                    >Section Id</label
                    >
                    <select
                        v-model="form.sectionId"
                        id="sectionId"
                        name="sectionId"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Select Section Id</option>
                        <option :value="section.id" v-for="(section,index) in sections">{{ section.title }}</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.sectionId"
                    />
                </div>

                <div class="block w-full">
                    <label
                        for="live"
                        class="block text-sm font-medium text-gray-700"
                    >Live</label
                    >
                    <select
                        v-model="form.live"
                        id="live"
                        name="live"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Topic is Live or not?</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.live"
                    />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button
                type="button"
                class="
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-4
                    py-2
                    bg-green-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-green-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-green-500
                    sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="submit()"
            >
                Save
            </button>
            <button
                type="button"
                class="
                    mt-3
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-gray-300
                    shadow-sm
                    px-4
                    py-2
                    bg-white
                    text-base
                    font-medium
                    text-gray-700
                    hover:bg-gray-50
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-indigo-500
                    sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="close()"
                ref="cancelButtonRef"
            >
                Cancel
            </button>
        </template>
    </dialog-model>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import InputError from "@/Components/InputError";
import { useForm } from "@inertiajs/inertia-vue3";
import DialogModel from "@/Components/DialogModel.vue";

export default {
    data() {
        return {
            open: false,
            form: useForm(
                {
                    id: "",
                    title: "",
                    sectionId: "",
                    topicOrder: "",
                    live: "",
                }
            ),
        };
    },
    props: {
        topics: Array,
        sections: Array,
        content: Number,
        slug: String,
        resource: Number,
    },
    methods: {
        close() {
            this.form.clearErrors();
            this.form.reset();
            this.open = false;
        },
        submit() {
            // update request
            this.form.put(
                route(
                    'admin.plans.resource.topic.update',
                    {
                        plan: this.slug,
                        resource: this.resource,
                        topic: this.form.id
                    }
                ),
                {
                    onSuccess: () => this.close(),
                    preserveScroll: true,
                }
            );
        },
        edit(topic) {
            this.form.title = topic.title;
            this.form.id = topic.id;
            this.form.live = topic.live;
            this.form.topicOrder = topic.topicOrder;
            this.form.sectionId = topic.sectionId;
            this.open = true;
        },
    },
    components: {
        DialogModel,
        BreezeAuthenticatedLayout,
        InputError,
    },
};
</script>
